import { MagnifyingGlassIcon } from "@phosphor-icons/react/dist/csr/MagnifyingGlass";
import { ShortcutKbd } from "@volca/ui/components/ui/shortcut-kbd";
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@volca/ui/components/ui/sidebar";
import { useCommandMenu } from "./command-menu";

export const CommandMenuTrigger = () => {
  const { setOpen, opensOnHelp } = useCommandMenu();
  const label = opensOnHelp ? "Search help" : "Search";

  return (
    <SidebarGroup className="px-2 pt-0 pb-1">
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            tooltip={label}
            variant="outline"
            type="button"
            className="text-subtle"
            aria-label={label}
            aria-keyshortcuts="Meta+K Control+K"
            onClick={() => setOpen(true)}
          >
            <MagnifyingGlassIcon />
            <span data-sidebar="search-copy">
              <span className="whitespace-nowrap">{label}</span>
              <ShortcutKbd
                keys={["mod", "K"]}
                className="ml-auto shrink-0 max-md:hidden"
              />
            </span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
};
